import { handleChunkLoadError } from '@hydra/utils/handleChunkLoadError';

export default ({
  path: 'dashboard/:url',
  async getComponent () {
    const {
      default: DashboardContainer
    } = await import(/* webpackChunkName: "dashboard-container" */ './containers/DashboardContainer')
      .catch(handleChunkLoadError);
    return DashboardContainer;
  },
  getData ({ context }) {
    return context.props;
  }
});
